import React, { useEffect, useState } from 'react';
import Title from 'components/UI/Title';
import Search from 'components/UI/Search';
import RecentReservationsTable from 'components/BusinessLogic/Reservation/RecentReservationsTable/Card';
import CommissionReceived from 'components/BusinessLogic/Reservation/ReservationsCommissionReceived/Card';
import Zinrelo from 'components/BusinessLogic/Zinrelo/Card';
import ContactUs from 'components/UI/ContactUs';
import PendingPayments from 'components/BusinessLogic/PendingPayments/Card';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import { buildZinrelosSelector } from 'store/selectors/zinrelos.selector';
import OpenQuotes from 'components/BusinessLogic/OpenQuotes/Card';
import MemberReports from 'components/BusinessLogic/MemberReports';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import Row from 'components/UI/Layout/Row';

function HomePage({ authMember, isB2cPage, getStoredZinrelo })
{
    const [storedZinrelo, setStoredZinrelo] = useState(null);

    useEffect(() =>
    {
        if (authMember?.defaultEmail)
        {
            const zinreloData = getStoredZinrelo(authMember.defaultEmail);
            setStoredZinrelo(zinreloData);
        }
    }, [authMember, getStoredZinrelo]);

    /**
     * We show the Zinrelo component only
     * if the user is already registered in the external rewards,
     * and we consider the user as registered if the information
     * from Zinrelo have an email and name defined
     * @type {boolean}
     */
    const showZinrelo = !isB2cPage
        && !_.isEmpty(storedZinrelo)
        && !_.isEmpty(_.get(storedZinrelo, 'email'))
        && !_.isEmpty(_.get(storedZinrelo, 'name'));

    return (
        <div className="tw-p-10 max-sm:tw-p-2 lg:tw-pl-[248px] tw-flex tw-flex-col tw-flex-1 tw-w-full h-full">
            <div className="tw-flex tw-gap-3 max-sm:tw-gap-0">
                <Row className="tw-w-full">
                    <Row className="tw-items-center">
                        <Title title={`Hi ${authMember.first_name}!`} className="primary tw-pr-4 max-sm:tw-hidden" margin="tw-mt-0 tw-px-4" />
                    </Row>
                    <Search className="tw-pl-4 max-sm:tw-px-12 max-sm:tw-col-span-2 tw-self-center tw-ml-auto tw-mr-0 max-xl:tw-max-w-full max-xl:tw-pl-0 tw-right-0" />
                </Row>
            </div>

            <div className="tw-grid tw-grid-cols-3 max-lg:tw-grid-cols-2 max-md:tw-grid-cols-1">
                <div className="tw-col tw-px-3 tw-mt-3">
                    <MemberReports isB2cPage={isB2cPage} />
                </div>
                <div className="tw-col tw-mt-3">
                    <ContactUs isB2cPage={isB2cPage} />
                </div>
            </div>
            <div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-mb-5 max-md:tw-grid-cols-1">
                {!isB2cPage && (<CommissionReceived hideOptions />)}
                <PendingPayments />
                <RecentReservationsTable />
                <OpenQuotes />
                {showZinrelo && (<Zinrelo />)}
            </div>
            {/* <TicketsTable /> */}

            <Helmet title={`Travel Agent Dashboard | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Home" />
            </Helmet>
        </div>
    );
}

HomePage.defaultProps = {
    isB2cPage: false,
};

HomePage.propTypes = {
    authMember: PropTypes.object,
    isB2cPage: PropTypes.bool,
    getStoredZinrelo: PropTypes.func,
};

const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();
    const zinreloSelector = buildZinrelosSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
        getStoredZinrelo: (email) => zinreloSelector(state, email),
    });
};

export default connect(mapStateToProps)(HomePage);
